module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/coins-2f9b8886d62719ba70f95ee809bfe74d.png";